import 'react-credit-cards/es/styles-compiled.css';

import React, { ChangeEvent, FocusEvent } from 'react';

import Cards from 'react-credit-cards';

type FocusedField = 'name' | 'number' | 'expiry' | 'cvc' | undefined;
 
export default class CreditCard extends React.Component {
  state = {
    cvc: '123',
    expiry: '1232',
    focus: undefined as FocusedField,
    name: 'Cauan R. Barbosa',
    number: '0000 9999 5555 5555',
  };
 
  handleInputFocus = (e: { target: { name: any; }; }) => {
    this.setState({ focus: e.target.name });
  }
  
  handleInputChange = (e: { target: { name: any; value: any; }; }) => {
    const { name, value } = e.target;
    
    this.setState({ [name]: value });
  }
  
  render() {
    return (
      <div
        id="CreditCard"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: '500px',
          margin: 'auto',
          textAlign: 'center',
          marginTop: '20px',
          marginBottom: '30px',
          borderRadius: '9%',
          boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.4)',
        }}>
        <Cards
          cvc={this.state.cvc}
          expiry={this.state.expiry}
          focused={this.state.focus}
          name={this.state.name}
          number={this.state.number}
          issuer={'Merda'}

        />
        {/* <form style={{ marginTop: '20px' }}>
          <input
            type="tel"
            name="number"
            placeholder="Card Number"
            onChange={this.handleInputChange}
            onFocus={this.handleInputFocus}
            style={{
              display: 'block',
              width: '100%',
              padding: '10px',
              margin: '10px 0',
              borderRadius: '5px',
              border: '1px solid #ccc',
            }}
          />
          <input
            type="text"
            name="name"
            placeholder="Name"
            onChange={this.handleInputChange}
            onFocus={this.handleInputFocus}
            style={{
              display: 'block',
              width: '100%',
              padding: '10px',
              margin: '10px 0',
              borderRadius: '5px',
              border: '1px solid #ccc',
            }}
          />
          <input
            type="tel"
            name="expiry"
            placeholder="Expiry Date"
            onChange={this.handleInputChange}
            onFocus={this.handleInputFocus}
            style={{
              display: 'block',
              width: '100%',
              padding: '10px',
              margin: '10px 0',
              borderRadius: '5px',
              border: '1px solid #ccc',
            }}
          />
          <input
            type="tel"
            name="cvc"
            placeholder="CVC"
            onChange={this.handleInputChange}
            onFocus={this.handleInputFocus}
            style={{
              display: 'block',
              width: '100%',
              padding: '10px',
              margin: '10px 0',
              borderRadius: '5px',
              border: '1px solid #ccc',
            }}
          />
        </form> */}
      </div>
    );
  }
}